import {
  getPartStyleFromStyleInterpolation,
  type StyleFunctionProps,
  type StyleObjectNonMulti,
} from '@frontend/legacy-components/src/theme/styleConfigHelpers';

import { INPUT_STYLE_CONFIG } from '../input/inputStyleConfig';
import type {
  TextareaColorScheme,
  TextareaSize,
  TextareaStyleConfig,
  TextareaVariant,
} from './types';

const baseStyle: TextareaStyleConfig['baseStyle'] = ({ theme, colorMode }) => {
  const inputFieldStyles = getPartStyleFromStyleInterpolation(
    INPUT_STYLE_CONFIG.baseStyle,
    'field',
    { theme, colorMode },
  );

  return {
    ...inputFieldStyles,
    py: 0.5,
  };
};

const getBaseSizeStyles = (
  size: TextareaSize,
  {
    theme,
    colorMode,
  }: StyleFunctionProps<TextareaVariant, TextareaColorScheme>,
): StyleObjectNonMulti | undefined =>
  getPartStyleFromStyleInterpolation(INPUT_STYLE_CONFIG.sizes[size], 'field', {
    theme,
    colorMode,
  });

const SIZES: TextareaStyleConfig['sizes'] = {
  sm: (styleFunctionProps) => ({
    ...getBaseSizeStyles('sm', styleFunctionProps),
    minHeight: 8,
  }),
  md: (styleFunctionProps) => ({
    ...getBaseSizeStyles('md', styleFunctionProps),
    minHeight: 10,
  }),
  lg: (styleFunctionProps) => ({
    ...getBaseSizeStyles('lg', styleFunctionProps),
    minHeight: 12,
  }),
};

const DEFAULT_PROPS = {
  size: 'md',
} as const;

export const TEXTAREA_STYLE_CONFIG: TextareaStyleConfig = {
  baseStyle,
  sizes: SIZES,
  defaultProps: DEFAULT_PROPS,
};
